import Qs from 'qs';

import ENV_VARS from '../utils/envVars';
import { removeEmptyValues } from '../utils/apiCaller';

export const USER_PROFILE_SUCCESS = 'USER_PROFILE_SUCCESS';
export const USER_PROFILE_FAILURE = 'USER_PROFILE_FAILURE';
export const AUTH_USER_PROFILE_SUCCESS = 'AUTH_USER_PROFILE_SUCCESS';
export const AUTH_USER_PROFILE_FAILURE = 'AUTH_USER_PROFILE_FAILURE';
export const GET_TARGETS_SUCCESS = 'GET_TARGETS_SUCCESS';
export const GET_TARGETS_FAILURE = 'GET_TARGETS_FAILURE';
export const USER_SEARCH_SUCCESS = 'USER_SEARCH_SUCCESS';
export const USER_SEARCH_FAILURE = 'USER_SEARCH_FAILURE';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE';
export const WEIGH_INS_SUCCESS = 'WEIGH_INS_SUCCESS';
export const WEIGH_INS_FAILURE = 'WEIGH_INS_FAILURE';
export const BODY_FATS_SUCCESS = 'BODY_FATS_SUCCESS';
export const BODY_FATS_FAILURE = 'BODY_FATS_FAILURE';
export const MEASUREMENTS_SUCCESS = 'MEASUREMENTS_SUCCESS';
export const MEASUREMENTS_FAILURE = 'MEASUREMENTS_FAILURE';
export const PENDING_CLIENT_SEARCH_SUCCESS = 'PENDING_CLIENT_SEARCH_SUCCESS';
export const PENDING_CLIENT_SEARCH_FAILURE = 'PENDING_CLIENT_SEARCH_FAILURE';
export const GET_PLAN_SUCCESS = 'GET_PLAN_SUCCESS';
export const GET_PLAN_FAILURE = 'GET_PLAN_FAILURE';
export const GET_MEMBERSHIP_SUCCESS = 'GET_MEMBERSHIP_SUCCESS';
export const GET_MEMBERSHIP_FAILURE = 'GET_MEMBERSHIP_FAILURE';
export const SET_PASSWORD_FOR_USER_SUCCESS = 'SET_PASSWORD_FOR_USER_SUCCESS';
export const SET_PASSWORD_FOR_USER_FAILURE = 'SET_PASSWORD_FOR_USER_FAILURE';
export const GET_ALL_CLIENTS_SUCCESS = 'GET_ALL_CLIENTS_SUCCESS';
export const GET_ALL_CLIENTS_FAILURE = 'GET_ALL_CLIENTS_FAILURE';
export const ADMIN_SEARCH_SUCCESS = 'ADMIN_SEARCH_SUCCESS';
export const ADMIN_SEARCH_FAILURE = 'ADMIN_SEARCH_FAILURE';
export const SYNC_INTERCOM_CONTACT_SUCCESS = 'SYNC_INTERCOM_CONTACT_SUCCESS';
export const SYNC_INTERCOM_CONTACT_FAILURE = 'SYNC_INTERCOM_CONTACT_FAILURE';
export const GET_DAILY_MACROS_SUCCESS = 'GET_DAILY_MACROS_SUCCESS';
export const GET_DAILY_MACROS_FAILURE = 'GET_DAILY_MACROS_FAILURE';
export const GET_ALL_USER_MACROS_SUCCESS = 'GET_ALL_USER_MACROS_SUCCESS';
export const GET_ALL_USER_MACROS_FAILURE = 'GET_ALL_USER_MACROS_FAILURE';
export const SET_CUSTOM_MACROS_SUCCESS = 'SET_CUSTOM_MACROS_SUCCESS';
export const SET_CUSTOM_MACROS_FAILURE = 'SET_CUSTOM_MACROS_FAILURE';

export function getUserProfile(user_id, fromAuth = false) {
  const config = {
    baseURL: ENV_VARS.BASE_URL,
    url: '/profile',
    method: 'GET',
    params: {
      user_id,
    },
  };
  return {
    type: 'API_CALL',
    config,
    auth: true,
    spinner: true,
    successAction: fromAuth ? AUTH_USER_PROFILE_SUCCESS : USER_PROFILE_SUCCESS,
    failureAction: fromAuth ? AUTH_USER_PROFILE_FAILURE : USER_PROFILE_FAILURE,
  };
}

export function getSparseUserProfile(user_id) {
  const config = {
    baseURL: ENV_VARS.BASE_URL,
    url: '/sparse-profile',
    method: 'GET',
    params: {
      user_id,
    },
  };
  return {
    type: 'API_CALL',
    config,
    auth: true,
    spinner: true,
    successAction: AUTH_USER_PROFILE_SUCCESS,
    failureAction: AUTH_USER_PROFILE_FAILURE,
  };
}

export function updateUserProfile(user_profile) {
  const config = {
    baseURL: ENV_VARS.BASE_URL,
    url: '/edit-client',
    method: 'PUT',
    data: user_profile,
  };
  return {
    type: 'API_CALL',
    config,
    auth: true,
    spinner: true,
    successAction: UPDATE_USER_SUCCESS,
    failureAction: UPDATE_USER_FAILURE,
  };
}

export function setPasswordForUserApi(user_id, new_password) {
  const config = {
    baseURL: ENV_VARS.BASE_URL,
    url: '/update-password',
    method: 'PUT',
    data: {
      user_id,
      new_password
    },
  };
  return {
    type: 'API_CALL',
    config,
    auth: true,
    spinner: true,
    successAction: SET_PASSWORD_FOR_USER_SUCCESS,
    failureAction: SET_PASSWORD_FOR_USER_FAILURE,
  };
}

export function getMacroTargets(user_id, team_id) {
  const config = {
    baseURL: ENV_VARS.BASE_URL,
    url: '/macros',
    method: 'GET',
    params: {
      user_id,
      team_id,
    },
  };
  return {
    type: 'API_CALL',
    config,
    auth: true,
    spinner: true,
    successAction: GET_TARGETS_SUCCESS,
    failureAction: GET_TARGETS_FAILURE,
  };
}

export function getDailyMacros(user_id, start_date, end_date) {
  const config = {
    baseURL: ENV_VARS.BASE_URL,
    url: '/daily-macros',
    method: 'GET',
    params: {
      user_id,
      date_start: start_date,
      date_end: end_date,
    },
  };
  return {
    type: 'API_CALL',
    config,
    auth: true,
    spinner: true,
    successAction: GET_DAILY_MACROS_SUCCESS,
    failureAction: GET_DAILY_MACROS_FAILURE,
  };
}

export function users() {
  const config = {
    baseURL: ENV_VARS.BASE_URL,
    url: '/clients',
    method: 'GET',
  };
  return {
    type: 'API_CALL',
    config,
    auth: true,
    spinner: true,
    successAction: USER_SEARCH_SUCCESS,
    failureAction: USER_SEARCH_FAILURE,
  };
}

export function getAllClientsApi(team_id, user_role_id) {
  const config = {
    baseURL: ENV_VARS.BASE_URL,
    url: '/clients',
    method: 'GET',
    params: { team_id, user_role_id },
    paramsSerializer(params) {
      return Qs.stringify(params, { arrayFormat: 'comma', encode: true });
    },
  };
  return {
    type: 'API_CALL',
    config,
    auth: true,
    spinner: true,
    successAction: user_role_id ? ADMIN_SEARCH_SUCCESS : GET_ALL_CLIENTS_SUCCESS,
    failureAction: user_role_id ? ADMIN_SEARCH_FAILURE : GET_ALL_CLIENTS_FAILURE,
  };
}

export function userSearch(values, type = 'user') {
  const scrubbedValues = removeEmptyValues(values);
  if (Object.keys(scrubbedValues).length === 0) {
    return users();
  }
  const config = {
    baseURL: ENV_VARS.BASE_URL,
    url: '/client-search',
    method: 'GET',
    params: scrubbedValues,
    paramsSerializer(params) {
      return Qs.stringify(params, { arrayFormat: 'comma', encode: true });
    },
  };
  return {
    type: 'API_CALL',
    config,
    auth: true,
    spinner: true,
    successAction: type === 'user' ? USER_SEARCH_SUCCESS : PENDING_CLIENT_SEARCH_SUCCESS,
    failureAction: type === 'user' ? USER_SEARCH_FAILURE : PENDING_CLIENT_SEARCH_FAILURE,
  };
}

export function addWeighInApi(user_id, values) {
  const config = {
    baseURL: ENV_VARS.BASE_URL,
    url: '/add-weigh-in',
    method: 'PUT',
    data: { user_id, ...values },
  };
  return {
    type: 'API_CALL',
    config,
    auth: true,
    spinner: true,
    successAction: WEIGH_INS_SUCCESS,
    failureAction: WEIGH_INS_FAILURE,
  };
}

export function updateWeighInApi(user_id, values) {
  const config = {
    baseURL: ENV_VARS.BASE_URL,
    url: '/edit-weigh-in',
    method: 'PUT',
    data: { user_id, ...values },
  };
  return {
    type: 'API_CALL',
    config,
    auth: true,
    spinner: true,
    successAction: WEIGH_INS_SUCCESS,
    failureAction: WEIGH_INS_FAILURE,
  };
}

export function deleteWeighInApi(user_id, date) {
  const config = {
    baseURL: ENV_VARS.BASE_URL,
    url: '/delete-weigh-in',
    method: 'PUT',
    data: { user_id, date },
  };
  return {
    type: 'API_CALL',
    config,
    auth: true,
    spinner: true,
    successAction: WEIGH_INS_SUCCESS,
    failureAction: WEIGH_INS_FAILURE,
  };
}

export function addBodyFatApi(user_id, values) {
  const config = {
    baseURL: ENV_VARS.BASE_URL,
    url: '/add-body-fat',
    method: 'PUT',
    data: { user_id, ...values },
  };
  return {
    type: 'API_CALL',
    config,
    auth: true,
    spinner: true,
    successAction: BODY_FATS_SUCCESS,
    failureAction: BODY_FATS_FAILURE,
  };
}

export function updateBodyFatApi(user_id, values) {
  const config = {
    baseURL: ENV_VARS.BASE_URL,
    url: '/edit-body-fat',
    method: 'PUT',
    data: { user_id, ...values },
  };
  return {
    type: 'API_CALL',
    config,
    auth: true,
    spinner: true,
    successAction: BODY_FATS_SUCCESS,
    failureAction: BODY_FATS_FAILURE,
  };
}

export function deleteBodyFatApi(user_id, date) {
  const config = {
    baseURL: ENV_VARS.BASE_URL,
    url: '/delete-body-fat',
    method: 'PUT',
    data: { user_id, date },
  };
  return {
    type: 'API_CALL',
    config,
    auth: true,
    spinner: true,
    successAction: BODY_FATS_SUCCESS,
    failureAction: BODY_FATS_FAILURE,
  };
}

export function addMeasurementsApi(user_id, values) {
  const config = {
    baseURL: ENV_VARS.BASE_URL,
    url: '/add-measurements',
    method: 'PUT',
    data: { user_id, ...values },
  };
  return {
    type: 'API_CALL',
    config,
    auth: true,
    spinner: true,
    successAction: MEASUREMENTS_SUCCESS,
    failureAction: MEASUREMENTS_FAILURE,
  };
}

export function updateMeasurementsApi(user_id, values) {
  const config = {
    baseURL: ENV_VARS.BASE_URL,
    url: '/edit-measurements',
    method: 'PUT',
    data: { user_id, ...values },
  };
  return {
    type: 'API_CALL',
    config,
    auth: true,
    spinner: true,
    successAction: MEASUREMENTS_SUCCESS,
    failureAction: MEASUREMENTS_FAILURE,
  };
}

export function deleteMeasurementsApi(user_id, date) {
  const config = {
    baseURL: ENV_VARS.BASE_URL,
    url: '/delete-measurements',
    method: 'PUT',
    data: { user_id, date },
  };
  return {
    type: 'API_CALL',
    config,
    auth: true,
    spinner: true,
    successAction: MEASUREMENTS_SUCCESS,
    failureAction: MEASUREMENTS_FAILURE,
  };
}

export function syncIntercomContact(user_id, team_id) {
  const config = {
    baseURL: ENV_VARS.BASE_URL,
    url: '/sync-intercom-contact',
    method: 'PUT',
    data: { user_id, team_id },
  };
  return {
    type: 'API_CALL',
    config,
    auth: true,
    spinner: true,
    successAction: SYNC_INTERCOM_CONTACT_SUCCESS,
    failureAction: SYNC_INTERCOM_CONTACT_FAILURE,
  };
}

export function getPlanApi(user_id, date) {
  const config = {
    baseURL: ENV_VARS.BASE_URL,
    url: '/plan',
    method: 'GET',
    params: {
      user_id,
      date,
    },
  };
  return {
    type: 'API_CALL',
    config,
    auth: true,
    spinner: true,
    successAction: GET_PLAN_SUCCESS,
    failureAction: GET_PLAN_FAILURE,
  };
}

export function getMembershipApi(user_id, date) {
  const config = {
    baseURL: ENV_VARS.BASE_URL,
    url: '/membership',
    method: 'GET',
    params: {
      user_id,
    },
  };
  return {
    type: 'API_CALL',
    config,
    auth: true,
    spinner: true,
    successAction: GET_MEMBERSHIP_SUCCESS,
    failureAction: GET_MEMBERSHIP_FAILURE,
  };
}

export function getAllUserMacros(user_id, team_id, date) {
  const config = {
    baseURL: ENV_VARS.BASE_URL,
    url: '/get-all-user-macros',
    method: 'GET',
    params: {
      user_id,
      team_id,
      date,
    },
  };
  return {
    type: 'API_CALL',
    config,
    auth: true,
    spinner: true,
    successAction: GET_ALL_USER_MACROS_SUCCESS,
    failureAction: GET_ALL_USER_MACROS_FAILURE,
  };
}

export function setCustomMacros(user_id, team_id, user_tz, macros) {
  const config = {
    baseURL: ENV_VARS.BASE_URL,
    url: '/set-custom-macros',
    method: 'POST',
    data: {
      user_id,
      team_id,
      user_tz,
      macros,
    }
  };
  return {
    type: 'API_CALL',
    config,
    auth: true,
    spinner: true,
    successAction: SET_CUSTOM_MACROS_SUCCESS,
    failureAction: SET_CUSTOM_MACROS_FAILURE,
  };
}
